import {Component, Input, OnInit} from '@angular/core';
import {Model} from '../../../../models/config/admin.model';
import {SweetUtil} from '../../../commons/sweet/sweet-util-service';
import {HttpService} from '../../../../services/http.service';
import {ModelList} from '../../../../models/config/model-list.model';
import {ModelFilter} from '../../../../models/config/model-filter.model';
import {ModelGroup} from '../../../../model-group/model-group.model';
import {Brand} from '../../../../brand/brand.model';
import {BrandService} from '../../../../brand/brand.service';

@Component({
  selector: 'app-model',
  templateUrl: './model.component.html',
  styleUrls: ['./model.component.scss']
})
export class ModelComponent implements OnInit {

  @Input()
  modelsActive: boolean;

  @Input()
  modelGroups: ModelGroup[];
  modelFilter: ModelFilter = new ModelFilter();
  modelList: ModelList;
  fuels = ['Benzine', 'BEV', 'Diesel', 'PHEV'];
  selectedBrand: Brand = null;
  brands: Array<Brand> = [];

  constructor(private http: HttpService, private sweetUtil: SweetUtil, private brandService: BrandService) {
  }

  ngOnInit(): void {
    this.brandService.all().subscribe((brands: Brand[]) => {
      this.brands = brands;
    });
    this.fetchModels();
  }

  sort() {
    this.modelFilter.sortAscending = !this.modelFilter.sortAscending;
    this.fetchModels();
  }

  changeModelPage(count: number) {
    this.modelFilter.page += count;
    this.fetchModels();
  }

  clearModelSearch() {
    this.modelFilter = new ModelFilter();
    this.fetchModels();
  }

  updateIconStatus() {
    return this.modelFilter.sortAscending ? 'assets/images/icon-sort-up.png' : 'assets/images/icon-sort-down.png';
  }

  addNewModel() {
    this.modelList.dataList.unshift(new Model());
  }

  fetchModels() {
    if (!this.modelsActive) {
      return;
    }
    this.http.fetchModels(this.modelFilter).subscribe((res) => {
      this.modelList = res;
    });
  }

  updateModel(model: Model) {
    this.http.saveModel(model).subscribe(() => {
      SweetUtil.showSuccess('Updated model').then();
    }, error => {
      if (error.status === 422) {
        this.sweetUtil.showError('Cannot save model. Date range conflicts with another record')
          .then();
      }
      if (error.status === 400) {
        this.sweetUtil.showError('Incomplete model data. Please ensure you have correctly captured all fields.').then();
      }
    });
  }

  removeModel(model: Model) {
    this.modelList.dataList.splice(this.modelList.dataList.indexOf(model), 1);
  }

  compare(a: ModelGroup, b: ModelGroup): boolean {
    return a && b && a.id === b.id;
  }

  compareFuel(a: string, b: string) {
    return a === b;
  }

  onBrandSelected($event: Event) {
    this.modelFilter.brand = this.selectedBrand.id;
    this.fetchModels();
  }
}
